import React, {useState, useEffect, useRef} from 'react';
import { 
    Flex, Box, Heading, FormControl, FormLabel, Input, Button, Text, CircularProgress,
    InputGroup, InputRightElement, Icon, Alert, AlertIcon, AlertDescription,
    useDisclosure, HStack, VStack, Image, Link, Center, useToast
} from '@chakra-ui/react';
import {
    ViewIcon, ViewOffIcon
} from '@chakra-ui/icons';
import { MdSettings } from 'react-icons/md';
import { FaGoogle, FaFacebook } from 'react-icons/fa';
import { Form, Field } from 'react-final-form';
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
import { useGoogleLogin, GoogleLogin, googleLogout } from "@react-oauth/google";
import FacebookLogin from '@greatsumini/react-facebook-login';
import ReCAPTCHA from 'react-google-recaptcha';
import axios from "axios";
import { withNamespaces } from 'react-i18next';
import { LOGIN_MAX_AGE, SELECTED_CLINIC_MAX_AGE, ERROR_CODES } from "../../constants";
import { displayConfirmAlert } from "../utils";
import httpClient from '../../services/http-client';
import ForgotPasswordModal from '../Home/Modals/ForgotPasswordModal';
import BrandName from '../../components/BrandName';

function LoginForm({ t }) {
    const [isLoading, setIsLoading] = useState(false);
    const [isHuman, setIsHuman] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    //const [googleResponse, setGoogleResponse] = useState(null);

    const handlePasswordVisibility = () => setShowPassword(!showPassword);

    const [ cookies, setCookie, removeCookie ] = useCookies(["loginCookie", "selectedClinic"]);
    const navigate = useNavigate();
  
    const toast = useToast();
    const captchaRef = useRef(null);
    const mounted = useRef();
    const initialRef = useRef(null);
    const forgotPasswordModal = useDisclosure();

    // useEffect(
    //     () => {
    //         if(googleResponse) {
    //             axios.get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${googleResponse.access_token}`, {
    //                 headers: {
    //                     Authorization: `Bearer ${googleResponse.access_token}`,
    //                     Accept: 'application/json'
    //                 }
    //             })
    //             .then(async(res) => {
    //                 const { email, name, picture, verified_email } = res.data;

    //                 let response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT_URL}/users/email/${email}`);
    //                 if(response.data && response.data.accessToken) {
    //                     setCookie("loginCookie", { token: response.data.accessToken, data: response.data.data }, { path: '/', maxAge: 5*(24*60*60) });
    //                     navigate("/");
    //                 } else {
    //                     setError("Đăng nhập bằng Google không thành công!");
    //                 }
    //             })
    //             .catch((err) => {
    //                 //console.log("get profile error", err)
    //                 setError("Đăng nhập bằng Google không thành công!");
    //             })
    //         }
    //     },
    //     [googleResponse]
    // )

    useEffect(() => {
        if(!mounted.current) {   
            if(cookies.loginCookie?.data) {
                navigate("/");
            }
            mounted.current = true;
        }
    });

    const handleChangeCaptcha = async(value) => {
        try
        {
            let response = await axios.post(`${process.env.REACT_APP_WEB_SERVER_URL}/authenticateReCaptcha`, {token: value}, {
                auth: {
                    username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                    password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                }
            })
            if(response.data && response.data.action === "Human") {
                setIsHuman(true);
            } else {
                setIsHuman(false);
            }
        }
        catch(error) {
            if(error?.code) {
                toast({
                    id: "global-error-info",
                    description: `${ERROR_CODES[error?.code]} (${error?.code})`,
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                    position: "bottom-right"
                });
            }
        }
    }

    const validate = (values) => {
        const errors = {};

        if(!values.phone) {
            errors.phone = "Required";
        }
        if(!values.password) {
            errors.password = "Required";
        }
        
        return errors;
    }

    const onSubmit = async(values) => {
        setIsLoading(true);

        try
        {
            let res = await httpClient.post("/authenticate", values);
            
            if(res.data && res.data.accessToken) {
                if(!cookies.selectedClinic?.data?.id || (cookies.selectedClinic?.data?.id && cookies.selectedClinic?.data?.id !== res.data?.data?.company_id)) {
                    setCookie("selectedClinic", { data: res.data?.data?.companyDetail }, { path: '/', maxAge: SELECTED_CLINIC_MAX_AGE });
                }
                setCookie("loginCookie", { token: res.data.accessToken, data: res.data.data }, { path: '/', maxAge: LOGIN_MAX_AGE });
                toast({
                    description: `Chào mừng '${res.data?.data?.full_name || res.data?.data?.phone}' trở lại!`,
                    status: "success",
                    duration: 5000,
                    isClosable: true,
                    position: "bottom-right"
                })
                navigate("/");
            } 
            else {
                if(res.data.errorCode === 4086) {
                    displayConfirmAlert("Phòng khám đã hết hạn sử dụng! Bạn vui lòng gia hạn trước khi tiếp tục sử dụng phần mềm", () => {
                        window.open(`/pricing/extend/${res.data?.data?.company_id}`);
                    })
                } else {
                    if(!toast.isActive("login-toast")) {
                        toast({
                            id: "login-toast",
                            title: `Đăng nhập thất bại`,
                            description: res.data.msg,
                            status: "warning",
                            duration: 3000,
                            isClosable: true,
                            position: "bottom-right"
                        })
                    }
                }
            }
        } 
        catch(error) {
            if(error?.code) {
                toast({
                    id: "global-error-info",
                    description: `${ERROR_CODES[error?.code]} (${error?.code})`,
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                    position: "bottom-right"
                });
            }
        }

        setIsLoading(false);
    }

    // const handleGoogleLogin = useGoogleLogin({
    //     onSuccess: (codeResponse) => {
    //         setGoogleResponse(codeResponse);
    //     },
    //     onError: (error) => {
    //         setError("Đăng nhập bằng Google không thành công!");
    //     },
        
    // });

    const handleGoogleLogout = () => {
        googleLogout();
    }

    // const responseFacebook = async(res) => {
    //     const { id, name, email, picture, } = res;

    //     //picture.data.url

    //     let response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT_URL}/users/email/${email}`);
    //     if(response.data && response.data.accessToken) {
    //         setCookie("loginCookie", { token: response.data.accessToken, data: response.data.data }, { path: '/', maxAge: 5*(24*60*60) });
    //         navigate("/");
    //     } else {
    //         setError("Đăng nhập bằng Facebook không thành công!");
    //     }
    // }

    return (
        <React.Fragment>
            <Form
                onSubmit={onSubmit}
                validate={validate}
                render={({ handleSubmit, form, submitting, pristine, valid, values }) => {
                    return (
                        <Flex flexDirection="column" width="full" height="100vh" bg="#F7F7F7" backgroundImage="/images/clinic-bg.jpeg">
                            <Flex justifyContent="flex-start" mt="2vh">
                                <Box width={{base: "100vw", md: "60vw", lg: "40vw", xl: "40vw"}} alignItems="center" 
                                    justifyContent="center" px={{ base: 4, md: 4, lg: 18, xl: 16 }} py={4}
                                >
                                    {/* <Link color="teal.500" href='/' fontWeight="700">Trở về trang chủ</Link> */}
                                    <Link href='/' _hover={{ textDecoration: "none" }}>
                                        <Text size="lg" textAlign="center" color="green.500" 
                                            fontSize={{base: "24px", md: "32px", lg: "32px", xl: "32px"}} fontWeight="700"
                                        >
                                            {t("Clinic_Management")}
                                        </Text>
                                    </Link>

                                    <Box p={8} borderWidth={1} borderRadius={8} boxShadow="lg" bg="#FFFFFF" marginTop="2vh">
                                        <Box textAlign="center">
                                            <Heading>{t("Login")}</Heading>
                                        </Box>

                                        <Box my={4} textAlign="left">
                                            <form onSubmit={handleSubmit}>
                                                <Field name="phone">
                                                    {({ input, meta }) => (
                                                        <FormControl mt={4} isRequired>
                                                            <FormLabel>{t("Phone")}</FormLabel>
                                                            <Input {...input} type='tel' />
                                                        </FormControl>
                                                    )}
                                                </Field>

                                                <Field name="password">
                                                    {({ input, meta }) => (
                                                        <FormControl mt={4} isRequired>
                                                            <FormLabel>{t("Password")}</FormLabel>
                                                            <InputGroup>
                                                                <Input 
                                                                    {...input}
                                                                    type={showPassword ? 'text' : 'password'}
                                                                    size="lg"
                                                                />
                                        
                                                                <InputRightElement width="3rem">
                                                                    <Button h="1.5rem" size="sm" onClick={handlePasswordVisibility}>
                                                                        {showPassword ? <ViewOffIcon /> : <Icon as={ViewIcon} />}
                                                                    </Button>
                                                                </InputRightElement>
                                                            </InputGroup>
                                                        </FormControl>
                                                    )}
                                                </Field>

                                                <Center mt={2}>
                                                    <ReCAPTCHA 
                                                        sitekey={process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY}
                                                        onChange={handleChangeCaptcha}
                                                        ref={captchaRef}
                                                    />
                                                </Center>

                                                <VStack alignItems="center">
                                                    {/* <Button colorScheme='green' width="full" mt={2} type='submit' isDisabled={!valid}> */}
                                                    <Button colorScheme='green' width="full" mt={2} type='submit' isDisabled={!valid || !isHuman}>
                                                        {
                                                            isLoading ? (
                                                                <CircularProgress isIndeterminate size="24px" color='orange'/>
                                                            ) : (
                                                                t("Login")
                                                            )
                                                        }
                                                    </Button>
                                                </VStack>
                                            </form>

                                            <VStack alignItems="center" mt={2}>
                                                {/* {
                                                    isExtendPricingService === false &&
                                                    <React.Fragment>
                                                        <Button colorScheme='blue' width="full" onClick={handleGoogleLogin}>
                                                            <Icon boxSize={4} as={FaGoogle} marginRight="8px"/> 
                                                            <Text fontSize="14px">Đăng nhập với Google</Text>
                                                        </Button>
                                                        <FacebookLogin 
                                                            appId={FACEBOOK_OAUTH_APP_ID}
                                                            onSuccess={(response) => {
                                                                // console.log('--- Login Success!', response)
                                                            }}
                                                            onFail={(error) => {
                                                                // console.log('--- Login Failed', error)
                                                                setError("Đăng nhập bằng Facebook không thành công!");
                                                            }}
                                                            onProfileSuccess={responseFacebook}
                                                            language='vi'
                                                            children="Đăng nhập với Facebook"
                                                            style={{
                                                                backgroundColor: '#4267b2',
                                                                color: '#fff',
                                                                fontSize: '16px',
                                                                padding: '12px 24px',
                                                                border: 'none',
                                                                borderRadius: '4px',
                                                                width: '100%'
                                                            }}
                                                        />
                                                    </React.Fragment>
                                                } */}
                                                <Link color="teal.500" href='/pricing/new' fontWeight="700">{t("Dont_Have_Account")}</Link>
                                                <Link href='#' fontWeight="700" onClick={() => forgotPasswordModal.onOpen()}>{t("Forgot_Password")}</Link>
                                                {/* <Link color="teal.500" href='/' fontWeight="700">Trở về trang chủ</Link> */}
                                            </VStack>
                                        </Box>
                                    </Box>
                                </Box>

                                <Box width={{base: "0vw", md: "40vw", lg: "60vw", xl: "60vw"}}>
                                    <Image alt="login_background" src="/images/login_background.png"/>
                                </Box>
                            </Flex>
                        </Flex>
                    )
                }}
            />

            <BrandName />
          
            {
                forgotPasswordModal.isOpen &&
                <ForgotPasswordModal 
                    initialRef={initialRef} isOpen={forgotPasswordModal.isOpen} onClose={forgotPasswordModal.onClose}
                />
            }                         
        </React.Fragment>
    )
}

export default withNamespaces()(LoginForm);